import React, { ComponentType, ReactElement, useEffect, useState } from 'react';

interface DelayRenderProps {
    delay?: number;
}

const delayRenderDecorator = function <Props extends DelayRenderProps>(
    Component: ComponentType<Props>,
): ComponentType<Props> {
    const DelayRenderComponent = (props: Props): ReactElement | null => {
        const { delay } = props;
        const [shouldRender, setShouldRender] = useState<boolean>(!delay);

        useEffect(() => {
            if (delay && !shouldRender) {
                setTimeout(() => setShouldRender(true), delay);
            }
        }, []);

        if (!shouldRender) return null;

        return <Component {...props} />;
    };

    return DelayRenderComponent;
};

export default delayRenderDecorator;
